export default __webpack_public_path__ + "static/media/banner with text-01.ddaa9ddb.jpg";